export default "__VITE_ASSET__WwM2Bs70__"